export enum NotificationStatus {
  SendInviteToSubjectSuccess,
  SendInviteToSubjectFail,
  RemoveSubjectFail,
  CallAliveSuccess,
  CallAliveFail,
  None,
}
